import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

// These views are loaded when the website is opened
import MainView from "../views/MainView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Main",
    component: MainView,
  },
  {
    path: "/unsubscribe",
    name: "Unsubscribe",
    component: () => import("../views/UnsubscribeView.vue"),
  },
];

// This is the router that is used to navigate between views
// History mode is used to remove the # from the URL
const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

export default router;
